var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAviation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#FCEEEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.208 17.865C27.9847 17.574 27.6651 17.372 27.3065 17.295C26.9479 17.2181 26.5735 17.2712 26.2505 17.445L24.1805 18.4875L19.013 16.545C18.9158 16.5095 18.8124 16.4945 18.7091 16.501C18.6058 16.5074 18.505 16.5352 18.413 16.5825L16.913 17.3325C16.7959 17.3912 16.6962 17.4795 16.6238 17.5887C16.5514 17.6979 16.5089 17.8242 16.5005 17.955C16.4934 18.086 16.5209 18.2167 16.5801 18.3338C16.6393 18.4509 16.7283 18.5505 16.838 18.6225L19.838 20.64L18.0005 21.585L16.163 20.3775C16.053 20.3047 15.9257 20.2622 15.7941 20.2543C15.6624 20.2464 15.5309 20.2733 15.413 20.3325L13.913 21.0825C13.8071 21.1353 13.7152 21.2124 13.6448 21.3076C13.5744 21.4028 13.5275 21.5132 13.508 21.63C13.4886 21.7476 13.4976 21.8681 13.5341 21.9816C13.5706 22.0951 13.6337 22.1982 13.718 22.2825L15.533 24.09C15.9546 24.512 16.5265 24.7494 17.123 24.75H17.2505C17.9768 24.7483 18.6929 24.5789 19.343 24.255L27.668 20.0925C27.8632 19.9949 28.0348 19.8559 28.1708 19.6852C28.3067 19.5145 28.4038 19.3162 28.4552 19.1041C28.5066 18.892 28.5112 18.6713 28.4685 18.4572C28.4258 18.2432 28.3369 18.0411 28.208 17.865Z",
    fill: "#84002A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviation);
export default __webpack_public_path__ + "static/media/aviation.03921ea96e8089d0765356edb0e8a9c9.svg";
export { ForwardRef as ReactComponent };